import { RESIZE_SCREEN } from 'actions/Types';

// eslint-disable-next-line import/prefer-default-export
export const resizeScreen = (data) => async (dispatch) => {
  dispatch({ type: RESIZE_SCREEN, isCollapse: data });
};
